'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-cd939937.js');
require('whatwg-fetch');
var secondLocation = require('../secondLocation.js');
var getUrlCacheIndex = require('../getUrlCacheIndex.js');
var isNumber = require('lodash/isNumber');
var localCache = require('../localCache.js');
var errors_formatError = require('../errors/formatError.js');
require('../localStore.js');
require('../memoryStorage.js');
require('../_storageService-be0124c8.js');
require('lodash/shuffle');
require('../errors/errorCodes.js');
require('../errors/appError.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isNumber__default = /*#__PURE__*/_interopDefaultLegacy(isNumber);

var FetchAMS = /** @class */ (function () {
    function FetchAMS() {
    }
    FetchAMS.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                options.method = 'get';
                return [2 /*return*/, this.request(url, options)];
            });
        });
    };
    FetchAMS.prototype.post = function (url, body, options) {
        options.body = body;
        options.method = 'post';
        return this.request(url, options);
    };
    FetchAMS.prototype.put = function (url, body, options) {
        options.body = body;
        options.method = 'put';
        return this.request(url, options);
    };
    FetchAMS.prototype.request = function (url, options) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var isExpiredRecord, cacheIndex, notExpiredCacheRow, useCache;
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                isExpiredRecord = false;
                useCache = !!((options === null || options === void 0 ? void 0 : options.useCache) && (options === null || options === void 0 ? void 0 : options.method) === 'get');
                if (options && useCache) { // it need for 2nd location
                    cacheIndex = getUrlCacheIndex.getUrlCacheIndex(url);
                    notExpiredCacheRow = localCache.localCache.get(cacheIndex, false); // returns something only if not expired
                    if (notExpiredCacheRow) {
                        notExpiredCacheRow.cached = true;
                        notExpiredCacheRow.ams_url = url.toString();
                        return [2 /*return*/, notExpiredCacheRow];
                    }
                    isExpiredRecord = !!localCache.localCache.get(cacheIndex, false, true);
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.call(url, options, function (err, res) {
                            if (!err) {
                                // if came back expired record from cache or from new request
                                if (useCache && (!res.cached || isExpiredRecord)) {
                                    delete res.cached;
                                    localCache.localCache.set(cacheIndex, res, (res.op || {}).cache_time);
                                }
                                resolve(res);
                            }
                            else {
                                if (useCache) {
                                    localCache.localCache.delIfExpire(cacheIndex);
                                }
                                reject(err);
                            }
                        }, cacheIndex, isExpiredRecord);
                    })];
            });
        });
    };
    FetchAMS.prototype.call = function (url, options, callback, cacheIndex, cacheState) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                fetch(url, options)
                    .then(function (res) {
                    response = res;
                    // if (!response.ok) {
                    //     /** to get response body if exists */
                    //     return response.json();
                    // } else {
                    //     return response.json()
                    // }
                    return response.json();
                })
                    .then(function (respJson) {
                    if (!response.ok) {
                        throw respJson;
                    }
                    else {
                        return respJson;
                    }
                })
                    .then(function (respJson) {
                    if (respJson === null || respJson === void 0 ? void 0 : respJson.error) { // AMS error like not 401 etc - don't need to handle by 2nd location logic
                        callback(errors_formatError.formatError(respJson, true, response || {}), null);
                    }
                    else {
                        callback(null, respJson || {});
                    }
                })
                    .catch(function (error) {
                    if ([403, 404, 402].indexOf(response === null || response === void 0 ? void 0 : response.status) !== -1) { // if AMS return 404
                        throw error;
                    }
                    if (secondLocation.secondLocation.isEnabled()) {
                        var nextAction = secondLocation.secondLocation.onBackendFailed(secondLocation.secondLocation.getBackDomain(), response === null || response === void 0 ? void 0 : response.status, cacheState);
                        if (nextAction === true) {
                            var urlInst = new URL(url);
                            urlInst.host = secondLocation.secondLocation.getBackDomain();
                            _this.call(urlInst.toString(), options, callback);
                        }
                        else if (nextAction === null && cacheIndex && localCache.localCache.get(cacheIndex, false, true)) {
                            var fromCache = localCache.localCache.get(cacheIndex, false, true);
                            fromCache.cached = true;
                            callback(null, fromCache);
                        }
                        else if (isNumber__default['default'](nextAction)) {
                            nextAction = nextAction;
                            setTimeout(function () {
                                _this.call(url, options, callback);
                            }, nextAction * 1000);
                        }
                        else {
                            throw error;
                        }
                    }
                    else {
                        throw error;
                    }
                })
                    .catch(function (error) {
                    return callback(errors_formatError.formatError(error, true, response || {}), null);
                });
                return [2 /*return*/];
            });
        });
    };
    return FetchAMS;
}());
var fetchAMS = new FetchAMS();

exports.FetchAMS = FetchAMS;
exports.fetchAMS = fetchAMS;
